module.exports = __webpack_public_path__ + "img/rule_img.3ab58992.png";